/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ExternalUploadDocumentsWizard_folders = {
    readonly nodes: ReadonlyArray<{
        readonly slug: string;
        readonly activeTicket: string;
        readonly parentType: string;
        readonly attachments: ReadonlyArray<{
            readonly id: string;
            readonly documentType: string | null;
        }>;
    } | null> | null;
    readonly " $refType": "ExternalUploadDocumentsWizard_folders";
};
export type ExternalUploadDocumentsWizard_folders$data = ExternalUploadDocumentsWizard_folders;
export type ExternalUploadDocumentsWizard_folders$key = {
    readonly " $data"?: ExternalUploadDocumentsWizard_folders$data;
    readonly " $fragmentRefs": FragmentRefs<"ExternalUploadDocumentsWizard_folders">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExternalUploadDocumentsWizard_folders",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Folder",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeTicket",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EntityAttachment",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "documentType",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FolderConnection",
  "abstractKey": null
};
(node as any).hash = '1bd8289c00113cbd953ddbc069604a6e';
export default node;
